import * as types from '@/constants/mutationTypes'

const state = {
  stepsList: {}
}
const getters = {
  stepsList: state => state.stepsList
}
const actions = {
  setStepsList ({commit}, data) {
    commit(types.SET_STEPS_LIST, {data})
  }
}
const mutations = {
  [types.SET_STEPS_LIST] (state, {data}) {
    state.stepsList = data
  }}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/Steps/modules/store.js